export const debounce = <Args extends any[]>(fn:(...args:Args) => any, delay: number) => {
    let timeout = null;
    return Object.assign(
        (...args:Args) => {
            if (timeout) {
                clearTimeout(timeout);
            }
            timeout = setTimeout(() => {
                fn(...args);
            }, delay||0);
        },
        {
            cancel: () => {
                if (timeout) {
                    clearTimeout(timeout);
                }
            },
        },
    );
};

export const debouncePromise = <Args extends any[], AwaitedReturn>(fn:(...args:Args) => Promise<AwaitedReturn>, delay: number) => {
    let timeout = null;
    return (...args:Args): Promise<AwaitedReturn> => {
        clearTimeout(timeout);
        return new Promise(function(resolve) {
            timeout = setTimeout(() => fn(...args).then(resolve), delay);
        });
    };
};

